import { z } from "zod";

export const platformFeaturesSchema = z.object({
  moduleAccessEnabled: z.boolean(),
});

export const workspaceModuleSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  nameBn: z.string(),
  description: z.string(),
  group: z.string(),
  requires: z.array(z.string()),
  granted: z.boolean(),
  enabled: z.boolean(),
  effective: z.boolean(),
  reason: z.string().nullable(),
});

export const workspaceModulesSchema = z.object({
  contractVersion: z.literal(1),
  catalogVersion: z.string().min(1),
  grantRevision: z.number().int().nonnegative(),
  appliedGrantRevision: z.number().int().nonnegative(),
  settingsRevision: z.number().int().nonnegative(),
  syncStatus: z.enum(["NOT_CONFIGURED", "PENDING", "APPLIED", "FAILED"]),
  syncError: z.string().nullable(),
  canManage: z.boolean(),
  modules: z.array(workspaceModuleSchema),
});

export const moduleGrantUpdateSchema = z.object({
  expectedRevision: z.number().int().nonnegative(),
  grants: z.record(z.string(), z.boolean()),
  reason: z.string().trim().min(1).max(500),
});

export const moduleSettingsUpdateSchema = z.object({
  expectedRevision: z.number().int().nonnegative(),
  enabled: z.record(z.string(), z.boolean()),
  reason: z.string().trim().min(1).max(500),
});

export function isModuleEntitlement(key: string): boolean {
  return key.startsWith("modules.");
}

export type WorkspaceModule = z.infer<typeof workspaceModuleSchema>;
export type WorkspaceModules = z.infer<typeof workspaceModulesSchema>;
export type ModuleGrantUpdate = z.infer<typeof moduleGrantUpdateSchema>;
export type ModuleSettingsUpdate = z.infer<typeof moduleSettingsUpdateSchema>;

export function organizationControlAccess(role: string | undefined, moduleAccessEnabled: boolean) {
  return {
    canManage: !moduleAccessEnabled || role === "OWNER" || role === "ADMIN",
    isOwner: !moduleAccessEnabled || role === "OWNER",
  };
}
